
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as faqdJ6MiaOXzoHpQox2KYYCm0_45FeZzEmJq4L36tHmMSR9oMeta } from "/codebuild/output/src1601896933/src/src/pages/faq.vue?macro=true";
import { default as menu3BhAKe_45HFGN4_Ch3tmxmz_5sZN4uQ1FWOSDX7qSonOoMeta } from "/codebuild/output/src1601896933/src/src/pages/menu.vue?macro=true";
import { default as index9zmqbETQ4JqAz8bbP7i6WFqxwBN1ymQQsVEAeayR688Meta } from "/codebuild/output/src1601896933/src/src/pages/index.vue?macro=true";
import { default as contact23_2jKpfRDn6sxASXPPAitgbOWiqYLv8GRwK2HDey50Meta } from "/codebuild/output/src1601896933/src/src/pages/contact.vue?macro=true";
import { default as tutorialt2RNL072wlGtX9zTrTQXZUtEzbci4cKHW81PWViJhNsMeta } from "/codebuild/output/src1601896933/src/src/pages/tutorial.vue?macro=true";
import { default as agreement3bNZ7MDb1VEOPvX3BAQTLdoZ818dV0ZSSbK_5ki2pK8Meta } from "/codebuild/output/src1601896933/src/src/pages/agreement.vue?macro=true";
import { default as about_45passmgfK5C9VEhDXS_45f8QZdHyMpSZoiYLsOD1_45mQBQiGovUMeta } from "/codebuild/output/src1601896933/src/src/pages/about-pass.vue?macro=true";
import { default as index2KgTLDqD3oaqLqdiXTmmsIWov1jKADI2mkSx7QK78NAMeta } from "/codebuild/output/src1601896933/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93wz2j2GyOBRRD2QqzNCJg7wDGi_45qJ7vnORJ_oyJeY7_AMeta } from "/codebuild/output/src1601896933/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancec_vUuosCLzEk_45TO6R_9_M8PQUNEbxUqEgdfOABSJfS0Meta } from "/codebuild/output/src1601896933/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93_45tGcK2eRzKnwUvVH4zThHMbahKgeO446N9xb0AmsxNYMeta } from "/codebuild/output/src1601896933/src/src/pages/notice/[id].vue?macro=true";
import { default as index9ePTty4JSgzQ3x_Rf0YBEx_3HU1rMXLjdx_45wH91G6C0Meta } from "/codebuild/output/src1601896933/src/src/pages/coupon/index.vue?macro=true";
import { default as indexdZWgOx0Y0lyr4AqzaDWW88XjY4_45t1DPt1j4C0xbY5UcMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/index.vue?macro=true";
import { default as indexI0ug13ZqluWv60vMcZWc_45oF_45ZqlsPnGoe0MG1uT07pUMeta } from "/codebuild/output/src1601896933/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93h_45fsseylEKPtYNtUbeSF20c0J5b2cGivWPgSWswW1I4Meta } from "/codebuild/output/src1601896933/src/src/pages/parking/[id].vue?macro=true";
import { default as index_452GwhFIjrWYXTH_bHwOV0rNPCC2y08_45XJZql1KI5Bg4Meta } from "/codebuild/output/src1601896933/src/src/pages/history/index.vue?macro=true";
import { default as indexbrUcQALrtBNnL4eaWEGAd7HkUrozpbcDLfbFJffdXucMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/index.vue?macro=true";
import { default as indexO2dmLJBJ1TZdIaCN7v97YA1l_45b2qFfCROBfxNJEeJhoMeta } from "/codebuild/output/src1601896933/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexBXpihfmTyT9ehOaqPi19sajZx06VRWJm6A7fZsPNMcsMeta } from "/codebuild/output/src1601896933/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviRaVMW1ABvMfCbG_t1B0i0Gd0pjK0aqLMAkPHsFstLMoMeta } from "/codebuild/output/src1601896933/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editglvQ9t_45QewntSaP8S10lF7_45dGHnkjPa8Yo_WThPumd0Meta } from "/codebuild/output/src1601896933/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementKT11usMmmUAj_45w4QSMLfUkhT_mEBzed1s1fGB7U65VUMeta } from "/codebuild/output/src1601896933/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexo6eJ6WwHVBA02B5DRsi9qil8_t1aU2BWpB8l2qXoWegMeta } from "/codebuild/output/src1601896933/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dSnKoEg0q4xW4cIMr0K40gQ7fNoJ7RylV34LAvJxRuyEMeta } from "/codebuild/output/src1601896933/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmQM_458XR__45t7WvY_45YrQirG_450ye6SxNVLagzjDeN1JBWooMeta } from "/codebuild/output/src1601896933/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexLd3YzPvd8gG5bWWRRIe41UWfU_45WWJ6pt6_45Vmb7KH9dAMeta } from "/codebuild/output/src1601896933/src/src/pages/card/create/index.vue?macro=true";
import { default as index4B1Ot7wMe7i42tBTzMbdFFBlv7eckPD4lFV8G_45fodV0Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmnEWCElxm3gfiyse8GEPQVjMfGvxM5USIRflWka_45cUhUMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmn_GVTXkqdQyUrPqihQb2VjbgaUXGjA0G5hZbSb0tG6gMeta } from "/codebuild/output/src1601896933/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeRnfNxE9QPgX6uQ1X4BewcNhHuTR0P5RzYfvf2hHTbnQMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/complete.vue?macro=true";
import { default as registerxF0GotL_vcdCaezeQStlllqGPqYGqBK0mb0WfLp_M8sMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93GDPA8WvJqyEY0RBhOW5DlkEV7WvTxnxI5qqxG5n6M48Meta } from "/codebuild/output/src1601896933/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmfbIEJK7t6GnSGT2fQuHEsy8myQo5lu8fQsD3fBdJWAIMeta } from "/codebuild/output/src1601896933/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_930PSz_454fY2yGTPMBb9zHJ6u7wMp_vXJQDKVMl0it2PaIMeta } from "/codebuild/output/src1601896933/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexzx0XVooWK9SUR619TJgqtLbaE8AtoKjGNcGl0d2l49sMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codecE_Zk3tZNXQJBniJsp7FK8gmnq2cuLOfhQazQSuRMtsMeta } from "/codebuild/output/src1601896933/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45code_g96688ELgcU5y_BG4_YLo2vkL2jl3vowGr5ssywJeIMeta } from "/codebuild/output/src1601896933/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeEf5hy0E0qxq4D7IH5WoZ_45jqXeLwmXAoFjXGY3fYndbUMeta } from "/codebuild/output/src1601896933/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registeria_457TO3BFnfAvGXRO9zrJaxy8AnKNzlBvcuKaS3Y8xUMeta } from "/codebuild/output/src1601896933/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeSO_45StXMCey94u6GgJopWFftab2XoOlG7YVLVW8QUuEUMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexVpe9NFqJfYw_DZQFt8nXge6yCnERsQSl_h_458FosE_JMMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmk64uInTnnQls4qqb5FuMpwuq0qXeGh5xBoiT8Pgvvc4Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeuDff6jLs56IkYpq5R4R54X8vFqi4aoGkwB35b5mxuIsMeta } from "/codebuild/output/src1601896933/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexYV33ut0IaY2eutgYYfuYBO_45bkCO4uJBWPxMri7MzM7oMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93x9ef9H91h1hU1Lj3v_45R6s41ZYC1rE13KpaqlU3wePNkMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete5krgrQ_45H7bbozZ6iviMfswRjqKdPqdQkEC8WcWNHKvgMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasBgQKv36WMiBgbkXPJwksU4c3OOXFDOeXk0Yq09zmzbsMeta } from "/codebuild/output/src1601896933/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplehJ8iDC_8Nx_iH1mEoUPjUYlmwYfATYZg0JNNAgMC3GcMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailAB2Yi7whpXf9KloGekhXrwllULdFVu7NzOeP8l82Ol0Meta } from "/codebuild/output/src1601896933/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmlCoF97Ka_45MGNwger4ps3nWhw1nkXZwjNknGaY2pfqEoMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentKu4zhWihXqOutkA0axe8TuVa_45ZN4nwEY_l4_45MBwI2jMMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmv5uRz5cxjLtWQ3095c0qvlUWxxRwIE5OqhsfkhiBY3cMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatear4evI77eIHtu_45mfFh87y_Ygb2nBfg3yRcoG8wbNFrgMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeW3EynnGHrGdFjYqMPww2DecvhVSvazX7iuPRw8VTC64Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codegtH3vW1XJB8gas4c5G_coqpvOTlOBYBkmBPcWmh3cdQMeta } from "/codebuild/output/src1601896933/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordwJ1FTYfwIzrjjqpzGeB_457kVErY1QWraVBIvb5ikGs4IMeta } from "/codebuild/output/src1601896933/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasZV2Q_eXoUn3x8ptgTDP_45J_45Xo15Qs1xXS0dJQLszS4w8Meta } from "/codebuild/output/src1601896933/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registeroVovXjdZgdEbJUi8KMbn42TGZ_45dS1dLDUhKRAFHOdAsMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codexNZxJyAxJpS94josZ2orzCWhqVIXN_454R38w71h4cNmkMeta } from "/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index9WEAGyyGfK0D8a5DZBPFxGPMihKz6luwQC6pMK3eJoEMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexN2bVTkpzx7JS4MYNNzA_45TlGJKkZpzsOPvt_45tAgxemQUMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexbZVieiqX9xuqFghjn57sao9MgYh0QCOvK4wDnst0E30Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexWjcr8nA0A6y6RjO4ZVZmxSErw1_PngkgPopnf6PCFQMMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updatezYYLfeDEnaqU_MwBNRqpUG7GqJ_wXC8XsvKL6Z5kHnYMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeLYxItDLSXFf_45b9ooNaXuchA5AcMcmATrp9ghqas5RA8Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmC_Nf5rs6rSj3tAV5Gb96ACB0CZDByI7kIh3elHQTPHYMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexRti0Z4LPRiMS1g5D4f5x_G2Pk0jCkpczSYuHgeqUApIMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete75N0V0RzCEWY9Z2rIJAL0hk7D6JoM85lX6icv0T7Do8Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update4A95dBDNDzLWSjPgywuIKJGEsC_45Jgt2h2DjUvvz3XpAMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexYSdNbEocmkEWN_452JLkH3mozLu0crDsBeC9fx0w8_45nfkMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexL7FuW4wv8Q_0Li2WVVljwijMKAP8Czz_45PoDBA2LLTGkMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete88NsUkgP7ZlexZ55Tz3l2KMTOXM8JszpyzFVJxjbw50Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index_cE2iTMyjEYLI9_45FKhTr4rBayxH9keAyfwYp58r6atMMeta } from "/codebuild/output/src1601896933/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeIzldDsyUpTo6_45xVEnOoMLp7seINsBzqInqsGeX2lV5YMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexPFHrr_45U1Y2irefKpGwxHlrRO_45ZXShqitWPjfkj4aV78Meta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexJo0WcxOjh_45Y_45M1S_458gzuaThnGNy9Mh3i8ybGKDj0mY0Meta } from "/codebuild/output/src1601896933/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as index0Akq9RPAX_45uX5q9_45Y6O7RIeo9_457E5I8wmVklk6me1O4Meta } from "/codebuild/output/src1601896933/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateFASSNSDjlbG9sPgQ71nxkqLCer5PRjsXR5Oli0WkYGEMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmX8C5ynRjIrrchxUwYliVFJNUlQMM5QdpxTb3F97zKtAMeta } from "/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu3BhAKe_45HFGN4_Ch3tmxmz_5sZN4uQ1FWOSDX7qSonOoMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index9zmqbETQ4JqAz8bbP7i6WFqxwBN1ymQQsVEAeayR688Meta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index9ePTty4JSgzQ3x_Rf0YBEx_3HU1rMXLjdx_45wH91G6C0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_452GwhFIjrWYXTH_bHwOV0rNPCC2y08_45XJZql1KI5Bg4Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexO2dmLJBJ1TZdIaCN7v97YA1l_45b2qFfCROBfxNJEeJhoMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexBXpihfmTyT9ehOaqPi19sajZx06VRWJm6A7fZsPNMcsMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexLd3YzPvd8gG5bWWRRIe41UWfU_45WWJ6pt6_45Vmb7KH9dAMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmnEWCElxm3gfiyse8GEPQVjMfGvxM5USIRflWka_45cUhUMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmn_GVTXkqdQyUrPqihQb2VjbgaUXGjA0G5hZbSb0tG6gMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeRnfNxE9QPgX6uQ1X4BewcNhHuTR0P5RzYfvf2hHTbnQMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerxF0GotL_vcdCaezeQStlllqGPqYGqBK0mb0WfLp_M8sMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmfbIEJK7t6GnSGT2fQuHEsy8myQo5lu8fQsD3fBdJWAIMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codecE_Zk3tZNXQJBniJsp7FK8gmnq2cuLOfhQazQSuRMtsMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45code_g96688ELgcU5y_BG4_YLo2vkL2jl3vowGr5ssywJeIMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeEf5hy0E0qxq4D7IH5WoZ_45jqXeLwmXAoFjXGY3fYndbUMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registeria_457TO3BFnfAvGXRO9zrJaxy8AnKNzlBvcuKaS3Y8xUMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmk64uInTnnQls4qqb5FuMpwuq0qXeGh5xBoiT8Pgvvc4Meta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeuDff6jLs56IkYpq5R4R54X8vFqi4aoGkwB35b5mxuIsMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexYV33ut0IaY2eutgYYfuYBO_45bkCO4uJBWPxMri7MzM7oMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete5krgrQ_45H7bbozZ6iviMfswRjqKdPqdQkEC8WcWNHKvgMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplehJ8iDC_8Nx_iH1mEoUPjUYlmwYfATYZg0JNNAgMC3GcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailAB2Yi7whpXf9KloGekhXrwllULdFVu7NzOeP8l82Ol0Meta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmlCoF97Ka_45MGNwger4ps3nWhw1nkXZwjNknGaY2pfqEoMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentKu4zhWihXqOutkA0axe8TuVa_45ZN4nwEY_l4_45MBwI2jMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmv5uRz5cxjLtWQ3095c0qvlUWxxRwIE5OqhsfkhiBY3cMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeW3EynnGHrGdFjYqMPww2DecvhVSvazX7iuPRw8VTC64Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codegtH3vW1XJB8gas4c5G_coqpvOTlOBYBkmBPcWmh3cdQMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordwJ1FTYfwIzrjjqpzGeB_457kVErY1QWraVBIvb5ikGs4IMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registeroVovXjdZgdEbJUi8KMbn42TGZ_45dS1dLDUhKRAFHOdAsMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codexNZxJyAxJpS94josZ2orzCWhqVIXN_454R38w71h4cNmkMeta || {},
    component: () => import("/codebuild/output/src1601896933/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1601896933/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]